module.exports = __webpack_public_path__ + "static/media/savio36.7698266f.jpg";